module.exports = __webpack_public_path__ + "img/derivados-yogurt.1927f031.png";